import { render, staticRenderFns } from "./RewardWidgetForm.vue?vue&type=template&id=ceada744&scoped=true&"
import script from "./RewardWidgetForm.vue?vue&type=script&lang=js&"
export * from "./RewardWidgetForm.vue?vue&type=script&lang=js&"
import style0 from "./RewardWidgetForm.vue?vue&type=style&index=0&id=ceada744&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceada744",
  null
  
)

export default component.exports